import { jsx } from 'react/jsx-runtime';
import { DayPicker } from 'react-day-picker';
import clsx from 'clsx';
import { format } from 'date-fns';
import { Caption } from './Caption.js';

function Calendar({
  rootClassName = '',
  selected,
  defaultMonth,
  onSelect,
  error,
  onMonthChange = () => {},
  disabledDays = [],
  preferredDays = [],
  ...rest
}) {
  const disabled = [...disabledDays];
  const root = clsx('text-navy w-full p-0 sm:p-sm rounded border-2 border-solid', rootClassName, {
    'border-red': !!error,
    'border-white': !error
  });
  const classNames = {
    root,
    day: 'w-lg h-lg rounded-full mx-xs sm:mx-2sm focus:border-0 [hover:not(aria-disabled="true")]:bg-white [hover:not(aria-disabled="true")]:text-dark-navy',
    head_cell: 'text-body uppercase',
    table: 'w-full',
    month: 'w-full'
  };
  return jsx(DayPicker, {
    defaultMonth: defaultMonth,
    mode: "single",
    selected: selected,
    onSelect: onSelect,
    disabled: disabled,
    weekStartsOn: 0,
    classNames: classNames,
    components: {
      Caption: ({
        displayMonth
      }) => jsx(Caption, {
        displayMonth: displayMonth,
        onChange: onMonthChange
      })
    },
    modifiers: {
      preferred: preferredDays
    },
    modifiersClassNames: {
      selected: 'bg-green text-white font-semibold',
      preferred: 'font-semibold'
    },
    formatters: {
      formatWeekdayName: date => format(date, 'EEE')
    },
    ...rest
  });
}

export { Calendar };
